import { DtNode } from './DtNode/DtNode';
import { RuleSetNode } from './RuleSetNode/RuleSetNode';
import { SrNode } from './SrNode/SrNode';

export const Components = {
  dtNode: DtNode,
  srNode: SrNode,
  ruleSetNode: RuleSetNode,
};
